import { requestAnimationFrame } from '../ADNDHelpers'
import { getState } from '../ADNDState'
import ADND from '../ADND'

const Z_INDEX_DND_LAYER = 9010

const props = {
  node: null
}

function dragLeave(event) {
  ADND().leftDocument(event)
}

let mouseMoveStopTimeout = null
function mouseMove(event) {
  if (event && 0 == event.buttons) {
    requestAnimationFrame(function () {
      const source = getState().source
      if (null == source) {
        if (null != mouseMoveStopTimeout) {
          clearTimeout(mouseMoveStopTimeout)
        }
        mouseMoveStopTimeout = setTimeout(() => {
          mouseMoveStopTimeout = null
          const adndModule = ADND()
          if (adndModule.isStarted()) {
            adndModule.stop(event)
          }
        }, 500)
      } else {
        source.CONNECT.dragEnd(event)
      }
    })
  }
}

const LAYER = {
  updatesState: false,
  start(/*event*/) {
    if (null == props.node) {
      const glass = document.createElement('div')
      glass.style.position = 'fixed'
      glass.style.left = 0
      glass.style.right = 0
      glass.style.top = 0
      glass.style.bottom = 0
      glass.style.background = 'transparent'
      glass.style.zIndex = Z_INDEX_DND_LAYER
      glass.style.width = '100%'
      glass.style.height = '100%'
      props.node = glass
      props.node.addEventListener('dragleave', dragLeave, true)
      props.node.addEventListener('mousemove', mouseMove, true)
      requestAnimationFrame(function () {
        if (null != props.node) {
          document.body.appendChild(props.node)
        }
      })
    }
    return LAYER
  },
  stop(/*event*/) {
    if (null != props.node) {
      const glass = props.node
      props.node = null
      glass.removeEventListener('dragleave', dragLeave, true)
      glass.removeEventListener('mousemove', mouseMove, true)
      requestAnimationFrame(function () {
        if (glass.parentNode == document.body) {
          document.body.removeChild(glass)
        }
      })
    }
    return LAYER
  }
}

export default function ADNDGlassLayer() {
  return LAYER
}
